import {
  GET_VENDING_EXTERNAL_SERVICES,
  convertResult,
} from 'app/common/api/requests/data/vending/external_services/get'

import { useCommonDataProvider, CommonDataOptions } from 'app/dataProviders/useCommonDataProvider'
import { VendingExternalServiceType } from 'app/dataTypes/vending/externalServices'


const defaultState: Array<VendingExternalServiceType> = []

type Op = CommonDataOptions<Array<VendingExternalServiceType>, void>

export function useVendingExternalServices(options: Op = {} as Op) {
  const res = useCommonDataProvider({
    ...options,
    requestValue: GET_VENDING_EXTERNAL_SERVICES,
    error: 'Не удалось получить внешние сервисы вендинга',
    convertions: {
      convertResult,
    },
    defaultState,
  })

  return res
}
